import { InsightMetric } from '@repo/types';
import {
  Card,
  Spinfinity,
  TaxaOverTimeLineChart,
  Typography,
} from 'components';
import { Suspense } from 'react';
import SubMetricBanner from '../SubMetricBanner/SubMetricBanner';
import styles from '../SubMetricGraphs.module.css';

interface OverTimeCardProps {
  metric: Partial<InsightMetric>;
}

export default function OverTimeCard({ metric }: OverTimeCardProps) {
  return (
    <Card>
      <Typography variant='heading-m' className='mb-3'>
        Over time
      </Typography>
      <Suspense fallback={<Spinfinity />}>
        <div className={styles.lineGraphContainer}>
          <TaxaOverTimeLineChart
            taxa={[metric?.sample_health_id ?? 0]}
            range={metric?.health_metrics_barscale_percentage ?? 0}
            dataType={metric?.data_type ?? 'percent'}
            animate
          />
        </div>
      </Suspense>
      <SubMetricBanner metricId={metric.sample_health_id} />
    </Card>
  );
}
